export default __webpack_public_path__ + "static/media/simple_92x82.ae94a264.svg";